import { createRoot } from "react-dom/client";
import { ReactElement } from "react";
import { MainMenu } from "./MainMenu/MainMenu";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import { ensureNotNil } from "client/Misc/utils";

export const MobileBar = (): ReactElement | null => {
	const isResponsive: boolean = useWorkspaceMediaQuery(MediaQueryKind.Responsive);

	if (!isResponsive) {
		return null;
	}

	return (
		<MainMenu />
	);
};
MobileBar.displayName="MobileBar";

export function init() {
	createRoot(
		ensureNotNil(
			document.getElementById("mobile-bar-host")
		)
	)
		.render(<MobileBar />);
}
